
import { defineComponent, PropType } from 'vue'
import DeliveryDatePickerInner from './DeliveryDatePickerInner.vue'
import { IHolidaysConfig } from '@/store/modules/main/intefaces/IConfig'

export default defineComponent({
  name: 'DeliveryDatePicker',

  props: {
    modelValue: {
      type: String,
      required: true
    },
    isCompact: {
      type: Boolean,
      default: false
    },
    shipmentId: {
      type: String,
      required: true
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    isSavedOrder: {
      type: Boolean,
      default: false
    },
    bypassFirstFetch: {
      type: Boolean,
      default: false
    },
    transparentBackground: {
      type: Boolean,
      default: false
    },
    blackVersion: {
      type: Boolean,
      default: false
    }
  },

  emits: ['update:modelValue', 'open', 'close'],

  components: {
    DeliveryDatePickerInner
  },

  data: () => ({
    componentKey: 0,
    isDatePickerOpened: false
  }),

  methods: {
    forceRecalculate () {
      this.componentKey += 1
    },

    onDatePickerOpened (opened: boolean) {
      this.isDatePickerOpened = opened
      // Emit event based on whether the date picker is opened or closed
      if (opened) {
        this.$emit('open') // Emit 'open' event when the date picker opens
      } else {
        this.$emit('close') // Emit 'close' event when the date picker closes
      }
    }
  }
})
